import { render, staticRenderFns } from "./TEvent.vue?vue&type=template&id=37d97adb&scoped=true&"
import script from "./TEvent.vue?vue&type=script&lang=ts&"
export * from "./TEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d97adb",
  null
  
)

export default component.exports